module.exports = __webpack_public_path__ + "static/img/no-data.ddcb5474.png";